import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// Strip null/undefined values so serialize() never sends "null" strings.
const clean = params =>
	Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== 'null'))

export const adminMediaKitList = (params = {}) => Http.get(`/admin/media-kits${serialize(clean(params))}`)
export const adminMediaKitCreate = (params = {}) => Http.post('/admin/media-kits', params)
export const adminMediaKitById = id => Http.get(`/admin/media-kits/${id}`)
export const adminMediaKitTogglePublish = id => Http.patch(`/admin/media-kits/${id}/toggle-publish`)
export const adminMediaKitDestroy = id => Http.delete(`/admin/media-kits/${id}`)
